import axios from "axios";
import _ from 'lodash';
import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import XLSX from 'xlsx';
import { utilities } from "../components/utilities";
import {
  UPLOAD_CERTIFICATIONS
} from "../constants/urlConstants";
import "./styles.css";
import { tr } from "date-fns/locale";

const UploadCertifications = ({ existingCertifications, fetchCertMasterList, trainingData }) => {
  const ref = useRef();

  const validCertFileHeaders = ['employee_id', 'certification_title', 'status', 'issued_by', 'certified_on', 'expires_on'];
  const [newCertifications, setNewCertifications] = useState([]);
  const [completedTrainingProgress, setCompletedTrainingProgress] = useState([]);
  const [completedTrainingModules, setCompletedTrainingModules] = useState([]);
  const [updateCertificationUsers, setUpdateCertificationUsers] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [isSubmitting, setSubmitting] = useState(false);
  const [fileUploaded, SetFileUploaded] = useState(false);
  const [uploadedFileHeaders, setUploadedFileHeaders] = useState([]);
  const employeeList = useSelector(
    (state) => state.EmployeeListReducer.employeeList
  );

  useEffect(() => {
    setTrainingList(trainingData ? trainingData : []);
  }, [trainingData]);


  const handleSubmit = async e => {
    if (!fileUploaded) {
      utilities.showToast("Please Upload a File!");
    } else {
      e.preventDefault();
      if (_.difference(validCertFileHeaders, uploadedFileHeaders).length !== 0) {
        utilities.showToast("Please upload file with valid headers");
      } else {
        let flag = false;
        // Remove entries with undefined or empty certification_title
        for (let i = updateCertificationUsers.length - 1; i >= 0; i--) {
          if (!updateCertificationUsers[i].certification_title) {
            updateCertificationUsers.splice(i, 1);
            flag = true;
          }
        }

        updateCertificationUsers.forEach((userData, userIndex) => {
          let index = employeeList.findIndex(data => {
            return userData.employee_id === data.employee_id
          });
          if (index < 0) {
            updateCertificationUsers.splice(userIndex, 1);
            flag = true;
          }
        });
        
        if (updateCertificationUsers.length > 0) {
          setSubmitting(true);

          axios.post(
            UPLOAD_CERTIFICATIONS, {
              newCertifications: newCertifications,
              updateCertificationUsers: updateCertificationUsers,
              completedTrainingProgress: completedTrainingProgress,
              completedTrainingModules: completedTrainingModules
            }
          ).then((response) => {
              setSubmitting(false);
              setNewCertifications([])
              setUpdateCertificationUsers([])
              setSubmitting(false)
              SetFileUploaded(false)
              setUploadedFileHeaders([])
              ref.current.value = "";
              if (response?.data?.errorMessage) {
                utilities.showToast(response.data.errorMessage);
              } else {
                fetchCertMasterList();
                utilities.showToast("File upload successful");
              }
            })
            .catch((err) => {
              setSubmitting(false);
              utilities.showToast("Failed to upload the file!");
            });
        }
        else {
          utilities.showToast("Please upload file with data");
        }
      }
    }
  };

  const processData = (fileData) => {
    // Clean file data by trimming keys and values
    const sanitizedFileData = sanitizeArrayOfObjects(fileData);

    // Get unique certification titles from existing certifications
    const filteredCertiNames = _.uniq(_.map(existingCertifications, 'certification_title'));

    // Find new certifications (not in existingCertifications)
    const tempNewCertificationsUsers = _.filter(sanitizedFileData, (fileItem) => fileItem.certification_title && !_.includes(filteredCertiNames, fileItem.certification_title));
    const tempNewCertifications = tempNewCertificationsUsers.map(cert => ({
      certification_title: cert.certification_title,
      issuing_authority: cert.issued_by
    }));

    // For each row in the file, find matching training/module and create completedTrainingModules
    let completedTrainingModules = [];
    sanitizedFileData.forEach(certRow => {
      trainingList.forEach(training => {
        (training.modules || []).forEach(module => {
          if (module.module_name === certRow.certification_title) {
            completedTrainingModules.push({
              employee_id: certRow.employee_id,
              training_id: training.training_id,
              module_id: module.module_id,
              score: 100,
              is_pass: true,
              score_percentage: 100,
            });
          }
        });
      });
    });

    // Group completedTrainingModules by employee_id and training_id
    const groupedByEmployeeTraining = _.groupBy(completedTrainingModules, m => `${m.employee_id}_${m.training_id}`);

    // For each group, create a completedTrainingProgress entry
    let completedTrainingProgress = [];
    Object.keys(groupedByEmployeeTraining).forEach(key => {
      const modules = groupedByEmployeeTraining[key];
      if (modules.length > 0) {
        const { employee_id, training_id } = modules[0];
        const training = trainingList.find(t => String(t.training_id) === String(training_id));
        completedTrainingProgress.push({
          training_id,
          employee_id,
          training_name: training ? training.training_name : undefined,
          progress_percentage: 100,
          is_complete: false,
          completion_date: null,
          last_updated: new Date().toISOString(),
          module_count: training ? training.modules.length : modules.length,
        });
      }
    });

    setNewCertifications(tempNewCertifications);
    setUpdateCertificationUsers(sanitizedFileData);
    setCompletedTrainingProgress(completedTrainingProgress);
    setCompletedTrainingModules(completedTrainingModules);
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      SetFileUploaded(true);
    }

    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = ({ target: { result } }) => {
      /* Parse data */
      //      const bstr = evt.target.result;
      const wb = XLSX.read(result, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      processData(convertToJson(data));
    };
    reader.readAsBinaryString(file);
  };

  const convertToJson = (csv) => {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");
    setUploadedFileHeaders(headers);

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }

    return result;
  }

    // Helper function to trim keys and values in file data
  function sanitizeArrayOfObjects(data) {
    return data.map(item => {
    const cleanedItem = {};
    Object.keys(item).forEach(key => {
      const trimmedKey = key.trim();
      const value = typeof item[key] === 'string' ? item[key].trim() : item[key];
      cleanedItem[trimmedKey] = value;
    });
    return cleanedItem;
    });
  }

  return (
    <form onSubmit={handleSubmit}>
      <h4>Upload the certificate spreadsheet</h4>
      <p>Please upload Excel in following format : {validCertFileHeaders.join(" ,")}</p>
      <input type="file" onChange={handleFileUpload} id="cert_file_upload" ref={ref} />
      {isSubmitting ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Upload
        </Button>
      )}
    </form>
  );
};

export default UploadCertifications;
